import locationModuleActions from "./location/actions";

export default {
  ...locationModuleActions
}
